<template>
  <div class="box">
    <p class="title is-5">
      Top Holdings Section
    </p>
    <div class="field">
      <b-switch
        v-model="showTopHoldings"
        @input="toggleCallback"
        type="is-success"
      >
        Show top holdings section
      </b-switch>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        showTopHoldings: true,
      }
    },
    props: {
      show: {
        type: Boolean,
        default: true
      },
      callback: Function,
    },
    methods: {
      toggleCallback: function() {
        this.callback.call(this, this.showTopHoldings);
      },
    },
    watch: {
      show: function() {
        this.showTopHoldings = this.show;
      }
    },
    created: function() {
      this.showTopHoldings = this.show;
    }
  }
</script>

<style scoped>
</style>